









import { Component, Vue, Prop } from 'vue-property-decorator';

import { IItem } from './types';

@Component
export default class ScoreItem extends Vue implements IItem {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: String, default: '' })
  readonly color!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/score/components/item/Item.vue